document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      menu.classList.toggle('is-open');
    });
  }

  var qtyInputs = document.querySelectorAll('[data-qty-input]');
  qtyInputs.forEach(function (input) {
    var minus = input.parentElement.querySelector('[data-qty-minus]');
    var plus = input.parentElement.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  var animated = document.querySelectorAll('[data-animate]');
  if ('IntersectionObserver' in window && animated.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    animated.forEach(function (el) { observer.observe(el); });
  } else {
    animated.forEach(function (el) { el.classList.add('is-visible'); });
  }

  var header = document.querySelector('header.main');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 12) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  var cartCount = document.querySelector('.cart-count');
  if (cartCount) {
    var lastCount = cartCount.textContent;
    var checkCartCount = function () {
      if (cartCount.textContent !== lastCount) {
        cartCount.classList.remove('is-updated');
        void cartCount.offsetWidth;
        cartCount.classList.add('is-updated');
        lastCount = cartCount.textContent;
      }
    };
    document.addEventListener('cart:updated', checkCartCount);
  }

  var countdowns = document.querySelectorAll('[data-countdown-target]');
  if (countdowns.length) {
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function renderCountdown(el) {
      var target = new Date(el.getAttribute('data-countdown-target')).getTime();
      if (isNaN(target)) { el.textContent = ''; return; }
      var diff = Math.max(0, target - Date.now());
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = pad(d) + 'j ' + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
      if (diff <= 0 && el.closest('[data-countdown-wrap]')) {
        el.closest('[data-countdown-wrap]').style.display = 'none';
      }
    }
    countdowns.forEach(function (el) {
      renderCountdown(el);
      setInterval(function () { renderCountdown(el); }, 1000);
    });
  }
});
